import { render, staticRenderFns } from "./EditGuidancePage.vue?vue&type=template&id=11a4e96a&"
import script from "./EditGuidancePage.vue?vue&type=script&lang=js&"
export * from "./EditGuidancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports